import { PaginatedResponse } from '@arpeggi/shared'

export const getPreviousPage = <T>(response: PaginatedResponse<T>) => {
  return response.meta.currentPage == 0 ? undefined : response.meta.currentPage - 1
}

export const getNextPage = <T>(response: PaginatedResponse<T>) => {
  return response.meta.lastPage <= response.meta.currentPage
    ? undefined
    : response.meta.currentPage + 1
}
